// extracted by mini-css-extract-plugin
export default {"wrapper":"Editable_wrapper__av6KZ","wrapper__input":"Editable_wrapper__input__+pPiJ"};